import React, { useContext, useState, useCallback } from 'react'
import './Styles/ShopCategory.css'
import { ShopContext } from '../Context/ShopContext'
// import dropdown_icon from '../Components/Assets/dropdown-arrowhead-64px.png'
import Item from '../Components/Item/Item'
import Filters from '../Components/Filters/Filters'

const ShopCategory = (props) => {

  const {all_products} = useContext(ShopContext);
  const [filteredProducts, setFilteredProducts] = useState([])
  const [showFilters, setShowFilters] = useState(false)

  // Pre-filtered by category before handing to Filters
  // Filters never sees other categories — its dynamic options (colors, sizes, tags)
  // are derived only from this category's products
  const categoryProducts = all_products.filter(p => p.category === props.category)

  const handleFilteredChange = useCallback((products) => {
      setFilteredProducts(products)
  }, [])

  const categoryLabel = props.category
      ? props.category.charAt(0).toUpperCase() + props.category.slice(1)
      : 'Products'

  return (
    <div className='shop-category'>

      {/* ── Header ── */}
      <div className="shop-category-page-header">
        <div className="shop-category-header-left">
          <h1>{categoryLabel}</h1>
          <p className="shop-category-count">
              {filteredProducts.length} of {categoryProducts.length} products
          </p>
        </div>
        {/* Mobile filter toggle */}
        <button className="shop-category-filter-toggle" onClick={() => setShowFilters(p => !p)} >
          {showFilters ? '✕ Hide Filters' : '⊞ Filters'}
        </button>
      </div>

      <div className="shop-category-body">

        {/* Filters sidebar — category is locked to this page's category */}
        <div className={`shop-category-filters-wrap ${showFilters ? 'shop-category-filters-wrap--open' : ''}`}>
          <Filters
              products={categoryProducts}
              lockedCategory={props.category}
              onFilteredChange={handleFilteredChange}
          />
        </div>

        {/* Product grid */}
        <div className="shop-category-grid-wrap">
          {filteredProducts.length === 0 && categoryProducts.length > 0 ? (
            <div className="shop-category-no-results">
              <p>No products match your filters.</p>
              <p className="shop-category-no-results-hint">Try removing some filters to see more results.</p>
            </div>
          ) : (
            <div className="shop-category-products">
              {filteredProducts.map(item => (
                <Item key={item.id} id={item.id} name={item.name} discount_percentage={item.discount_percentage} available={item.available} images={item.images} price={item.price} old_price={item.old_price} />
              ))}
            </div>
          )}
        </div>

      </div>
    </div>
  )
}

export default ShopCategory